<template>
  <div>
    <div style="padding-top:10px;margin-left:40px;margin-right:40px;">
      <!-- <img src="../../assets/neww.jpg"  style="width:100%; height:auto;"/> -->
      <v-carousel>
        <v-carousel-item
          v-for="(item,i) in items"
          :key="i"
          :src="item.src"
          reverse-transition="fade-transition"
          transition="fade-transition"
        ></v-carousel-item>
      </v-carousel>
    </div>
    <div style="margin-left:40px;margin-right:40px;">
      <v-row>
        <v-col md="4">
          <img src="../../assets/of1.png" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/ofr.png" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/rel.jpg" style="width:100%; height:auto;" />
        </v-col>
      </v-row>
    </div>
    <v-container class="ms">
      <v-card style="margin-top:10px;" height="100%" class="mx-auto">
        <v-row class="mb-6">
          <v-col md="4">
            <v-icon style="color:blue;padding-left:10px;font-size:50px;">mdi-car</v-icon>

            <v-card-title style="'padding-left:20px;">Fast Delivery</v-card-title>

            <p
              style="text-align:justify;padding-left:20px;"
            >Lorem ipsum, dolor sit amet consectetur adipisicing elit.Lorem ipsum, dolor sit amet consectetur adipisicing elit.Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
          </v-col>
          <br />
          <v-col md="4">
            <v-icon style="color:blue;padding-left:10px;font-size:50px;">mdi-domain</v-icon>

            <v-card-title>Creative Strategy</v-card-title>

            <p
              style="text-align:justify;padding-left:20px;"
            >Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
          </v-col>
          <br />
          <v-col md="4">
            <v-icon style="color:blue;padding-left:10px;font-size:50px;">mdi-lock</v-icon>

            <v-card-title>High Secured</v-card-title>

            <p
              style="text-align:justify;padding-left:20px;"
            >Lorem ipsum, dolor sit amet consectetur adipisicing elit.Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
          </v-col>
          <br />
        </v-row>
      </v-card>
    </v-container>

    <!-- <v-col md="6">
       
        <v-card-title style="'padding-left:20px;">Popular Products</v-card-title>
    </v-col>-->

    <!-- <v-row 
      class="mb-6 prod"
      no-gutters
      
       
    >
    
      <v-col md="3" style="padding-bottom:20px;"> 
        <v-card class="d-inline-block mx-auto">
    <v-container>
      <v-row justify="space-between">
        <v-col cols="auto">
          <v-img
            height="200"
            width="200"
            src="https://cdn.vuetifyjs.com/images/cards/store.jpg"
          ></v-img>
          <br>
          Winter Suit Good <br>
          $666
        </v-col>

        
      </v-row>
    </v-container>
  </v-card>
      </v-col>
      
       <v-col md="3" style="padding-bottom:20px;" >
       
         <v-card class="d-inline-block mx-auto">
    <v-container>
      <v-row justify="space-between">
        <v-col cols="auto">
          <v-img
            height="200"
            width="200"
            src="https://cdn.vuetifyjs.com/images/cards/store.jpg"
          ></v-img>
            <br>
          Winter Suit Good One<br>
            $666
        </v-col>

        <v-col
          cols="auto"
          class="text-center pl-0"
        >
     
        </v-col>
      </v-row>
    </v-container>
  </v-card>
      </v-col>
       <v-col md="3" style="padding-bottom:20px;">
         <v-card class="d-inline-block mx-auto">
    <v-container>
      <v-row justify="space-between">
        <v-col cols="auto">
          <v-img
            height="200"
            width="200"
            src="https://cdn.vuetifyjs.com/images/cards/store.jpg"
          ></v-img>
            <br>
          Winter Suit Good One  
          <br>
            $666
        </v-col>

        <v-col
          cols="auto"
          class="text-center pl-0"
        >
       
        </v-col>
      </v-row>
    </v-container>
  </v-card>
      </v-col>
      <v-col md="3" style="padding-bottom:20px;">
        <v-card class="d-inline-block mx-auto">
    <v-container>
      <v-row justify="space-between">
        <v-col cols="auto">
          <v-img
            height="200"
            width="200"
            src="https://cdn.vuetifyjs.com/images/cards/store.jpg"
          ></v-img>
            <br>
          Winter Suit Good One
           <br>
            $666
        </v-col>

        <v-col
          cols="auto"
          class="text-center pl-0"
        >
       
        </v-col>
      </v-row>
    </v-container>
  </v-card>
      </v-col>
      
    </v-row>-->

    <div style="margin-left:40px;margin-right:40px;">
      <v-row>
        <v-col md="4">
          <img src="../../assets/ph.png" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/me.jpg" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/rel.jpg" style="width:100%; height:auto;" />
        </v-col>
      </v-row>
    </div>

    <br />
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";
// import AppSideNav from "@/components/common/AppSideNav";

export default {
  props: ["id"],
  components: {
    // AppSideNav,
    StarRating
  },
  data() {
    return {
      items: [
        {
          src:
            "https://cdn.static-zoutons.com/images/originals/stores/Nykaa_App_1568270141.jpg"
        },
        {
          src:
            "https://cdn.static-zoutons.com/images/originals/stores/Flipkart_App_1569412752.jpg"
        },
        {
          src:
            "https://www.nokiacamp.com/wp-content/uploads/2018/10/Nokia-offer.jpg"
        },
        {
          src:
            "https://opt.toiimg.com/recuperator/img/toi/m-73692781/73692781.jpg?resizemode=1&width=215&height=145"
        }
      ],
      data: [],
      product: {
        name: null,
        price: null,
        desc: null,
        instock: null,
        seller: null,
        id: null,
        status: null
      }
    };
  },
  beforeMount() {
    this.getproduct();
  },
  methods: {
    getproduct() {
      axios({
        method: "GET",
        url: "/product/all/"
      }).then(Response => {
        this.data = Response.data.data;
        // console.log(Response);

        // var prodata = Response.data.data;
        // this.product.name = prodata.productname;
        // this.product.price = prodata.price;
        // this.product.desc = prodata.description;
        // this.product.instock = prodata.instock;
        // this.product.seller = prodata.seller;
        // this.product.id = prodata._id;
        // this.product.status = prodata.status;
      });
    }
  }
};
</script>

<style scoped>
@media (min-width: 360px) and (max-width: 760px) {
  .apple {
    width: 45%;
    height: auto;
  }
}
@media (min-width: 761px) and (max-width: 2000px) {
  .apple {
    width: 80%;
    height: auto;
  }
}
@media (min-width: 1264px) {
  .ms {
    max-width: 1300px !important;
  }
}
.v-toolbar__title {
  font-size: 0rem !important;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media only screen and (min-width: 960px) and (max-width: 1060px) {
  .AppHeading {
    font-size: 12px !important;
  }
}
.nav_item {
  margin-top: 5px;
  margin-right: 20px;
}
.AppHeading {
  color: black;
  font-family: proxima;
  font-size: 16px;
  font-weight: 800 !important;
  letter-spacing: 1px !important;
}
.AppMenu {
  color: white;
  font-family: opensans;
  font-size: 12px !important;
  font-weight: 100 !important;
  text-transform: uppercase;
}
@media only screen and (min-width: 360px) and (max-width: 760px) {
  .prod {
    margin-left: 50px;
    margin-right: 50px;
  }
}
@media only screen and (min-width: 761px) and (max-width: 2000px) {
  .prod {
    margin-left: 120px;
    margin-right: 120px;
  }
}
.down {
  padding-left: 40px;
}
</style>

